import * as React from 'react';
import type { IListPageLayoutSearchProps } from './list-page-layout.types';
import { cn } from '@utils';

export const ListPageLayoutSearch = React.forwardRef<HTMLDivElement, IListPageLayoutSearchProps>(
	({ className, children, ...props }, ref) => (
		<div
			ref={ref}
			className={cn('flex items-center gap-2 flex-grow min-w-0', className)}
			data-testid="list-page-layout-search"
			{...props}
		>
			{children}
		</div>
	)
);
ListPageLayoutSearch.displayName = 'ListPageLayoutSearch';
